// extracted by mini-css-extract-plugin
export var icon = "_73-1";
export var subtext = "_73-0";